// components/Footer/Footer.jsx
import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';

const PublicFooter = () => {
    return (
        <footer className="bg-gray-900 text-white">
            <div className="max-w-screen-xl mx-auto px-6 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Hospital Info */}
                    <div>
                        <h3 className="text-2xl font-bold mb-4">Omega Medium Clinic</h3>
                        <p className="text-gray-400 mb-6">
                            Providing compassionate healthcare.
                        </p>
                        <div className="flex space-x-4">
                            <a href="#" className="text-gray-400 hover:text-white"><FaFacebook size={20} /></a>
                            <a href="#" className="text-gray-400 hover:text-white"><FaTwitter size={20} /></a>
                            <a href="#" className="text-gray-400 hover:text-white"><FaLinkedin size={20} /></a>
                            <a href="#" className="text-gray-400 hover:text-white"><FaInstagram size={20} /></a>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="text-xl font-semibold mb-6">Contact Information</h4>
                        <div className="space-y-4">
                            <div className="flex items-center space-x-3">
                                <FaMapMarkerAlt className="text-blue-400" />
                                <span className="text-gray-400">Hossana, Central Ethiopia</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <FaPhone className="text-blue-400" />
                                <div>
                                    <p className="text-gray-400">General: +251-911-85-25-88</p>
                                    <p className="text-gray-400">Emergency: +251-911-85-25-88</p>
                                </div>
                            </div>
                            <div className="flex items-center space-x-3">
                                <FaEnvelope className="text-blue-400" />
                                <span className="text-gray-400">adeffa2011@yahoo.co.uk</span>
                            </div>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-xl font-semibold mb-6">Quick Links</h4>
                        <ul className="space-y-3">
                            <li><a href="/" className="text-gray-400 hover:text-white">Home</a></li>
                            <li><a href="/services" className="text-gray-400 hover:text-white">Services</a></li>
                            <li><a href="/departments" className="text-gray-400 hover:text-white">Departments</a></li>
                            <li><a href="/doctors" className="text-gray-400 hover:text-white">Doctors</a></li>
                            <li><a href="/announcements" className="text-gray-400 hover:text-white">Announcements</a></li>
                        </ul>
                    </div>

                    {/* Legal */}
                    <div>
                        <h4 className="text-xl font-semibold mb-6">Legal</h4>
                        <ul className="space-y-3">
                            <li><a href="#" className="text-gray-400 hover:text-white">Privacy Policy</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white">Terms & Conditions</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white">Cookie Policy</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white">Disclaimer</a></li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
                    <p>&copy; {new Date().getFullYear()} Humble Software Solution. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default PublicFooter;